import React, {useState, useEffect} from 'react';
import { Card } from '@mui/material';
import { Typography } from '@mui/material';
import { TextField } from '@mui/material';
import { Button } from '@mui/material';
import { Alert } from '@mui/material';
import { Divider } from '@mui/material';
import { BrowserRouter as Router, Route, Routes, Link, useNavigate } from 'react-router-dom'
import { List } from '@mui/material';
import { ListItem } from '@mui/material';
import { FaPencilAlt } from 'react-icons/fa';
import { FaSignOutAlt } from 'react-icons/fa';
import { FaBackspace } from 'react-icons/fa';
import { FaFileAudio } from 'react-icons/fa';
import { FaHandshake } from 'react-icons/fa';
import { FaKey } from 'react-icons/fa';
import { FaTrashAlt } from 'react-icons/fa';
import { ToastContainer, toast } from 'react-toastify';
import Lottie from "lottie-react";
import Loading from "./98635-loading.json";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { getJWT, isAdmin as checkIsAdmin } from '../../utils/auth';

    

const AdminCreateRelay = () => {
    const usernameString = localStorage.getItem('username');
    const username = JSON.parse(usernameString);
    const navigate = useNavigate();
    
    
  const [usersData, setUsers] = useState([]);
  const [isAdmin, setIsAdmin] = useState([]);
  const [addRelay, setAdddRelay] = useState([]);
  const [addRelayURL, setAdddRelayURL] = useState([]);
  const [relayDestination, setRelayDestination] = useState([]);
  const [addPassword, setAddPassword] = useState([]);
  const [addStreamTitle, setAdddStreamtitle] = useState([]);
  const [addImageURL, setAddImageURL] = useState([]);
  const [addMobileStreamDesc, setMobileStreamDesc] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [allMountpoints, setAllMountpoints] = useState([]);
  const [assignedMountpoint, setAssignedMountpoint] = useState([]);

   const adminChecker = async () => {
     const jwt = getJWT();
     if (jwt) {
       setIsAdmin(checkIsAdmin() ? "true" : "false");
       return jwt;
     }
     return null;
   }
  
const changeToDestination = async (e) => {
  e.preventDefault();
  var handledAssignedMP = e.target.value
  setRelayDestination(handledAssignedMP)
}

  async function fetchMPFunction(credentials) {
    return fetch('https://catalina.xseu.net/beheer-pz/distinctMountpointsAdmin', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(credentials)
    })
      .then(data => data.json())
   }

   const fetchMP = async () => {
    var isAdminString = await adminChecker();

    const token = await fetchMPFunction({
     username: username,
     isAdmin: isAdminString
    });
    setAllMountpoints(token)
    setIsLoading(false)
  }

  let handleSubmit = async (e) => {
    e.preventDefault();
    var isAdminString = await adminChecker();

    try {
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: addRelay, origin: addRelayURL, destination: relayDestination, protocol: addRelayURL.split('://')[0], isAdmin: isAdminString })
    };
    let res = await fetch('https://catalina.xseu.net/beheer-pz/createRelayAdmin', requestOptions)
        .then(response => response.json())
      if (res.message === "Bijwerken geslaagd") {
        toast.success('Het toevoegen van de relay is geslaagd.', {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
          
      } else {
        toast.error('Het toevoegen van de relay is mislukt.', {
          position: "bottom-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {

adminChecker();
fetchMP();


 }, [])

 if (isLoading == true) {
  return (
    <div>
    <Card style={{padding: 10, boxShadow: "0 1px 22px 4px rgba(0,0,0,.07)" }}>
    <center>
    <Lottie animationData={Loading} style={{width: 50, height: 50}} />
    <Typography><strong>Laden...</strong></Typography>
    </center>
    </Card>
    </div>
  )
} else {


 if (isAdmin != "true") {
    return (
      <div>
      <Card style={{padding: 10, boxShadow: "0 1px 22px 4px rgba(0,0,0,.07)" }}>

      <Alert severity="error"><strong>Sorry, {username}! Je hebt geen rechten om dat te doen</strong></Alert>
      </Card>
      </div>
    )
  }


  return(
    <div>
              <Card style={{minHeight: 200, minWidth: '33', padding: 10, boxShadow: "0 1px 22px 4px rgba(0,0,0,.07)", marginBottom: 20 }}>
        <Alert severity='info' style={{marginBottom: 20, fontWeight: 'bold'}}>Relay toevoegen</Alert>
        <Button onClick={() => navigate(-1)}><FaBackspace style={{width: 30, height: 30, marginRight: 10, color: 'orange'}}/>Ga terug</Button>
        <center>
      <form onSubmit={handleSubmit}>
          <Typography style={{color: '#428bca'}}><strong>Naam van relay: </strong></Typography><TextField id="add_username" variant="outlined" name="add_username" style={{width: 200}} onChange={(e) => setAdddRelay(e.target.value)}>Naam van relay</TextField>
          <br />
          <Alert severity='warning' style={{marginTop: 10}}>Gebruik geen spaties! (eventueel streepjes)</Alert>
          <Typography style={{color: '#428bca'}}><strong>URL van stream: </strong></Typography><TextField id="add_username" variant="outlined" name="add_username" style={{width: 200}} onChange={(e) => setAdddRelayURL(e.target.value)}>URL van stream</TextField>
          <br />
          <Typography style={{color: '#428bca', fontWeight: 'bold'}}>Mountpoint</Typography>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={relayDestination}
          label="Mountpoint"
          style={{width: 200}}
          onChange={changeToDestination}
        >
            {allMountpoints.map((mountpoint, index) => (
          <MenuItem value={mountpoint.MP} key={index}>{mountpoint.MP}</MenuItem>
          ))}
        </Select>
          <Alert severity='warning' style={{marginTop: 10}}>Vergeet niet om de mountpoint op 'tonen' te zetten en de streaminfo toe te voegen!</Alert>
        <br />
        <Button variant="contained" type="submit" style={{marginTop: 10}}>Verzenden</Button>
        
        </form>
        </center>
        </Card>
        </div>


  );
 }
}

export default AdminCreateRelay;


